import { Table } from '../Enums/Table.enum';
import QuestionnaireResultTableItem from '../../../Components/Questionnaire/QuestionnaireResultTableItem';
import { HealthData } from '../Enums/HealthData.enum';

export interface HealthDataTableColumn {
	value: number | string;
	color: string;
	textColor: string;
	source?: string;
}

export const TABLE_COLUMNS = {
	[Table.BLOOD_PRESSURE]: {
		title: 'component.chart.filter.bloodPressureAndHearthBeat',
		columns: [
			{
				key: HealthData.BLOOD_PRESSURE_SYSTOLIC,
				title: 'Sistólica',
				renderItem: (item: {
					blood_pressure_systolic: HealthDataTableColumn;
				}) => {
					return (
						<QuestionnaireResultTableItem
							value={item.blood_pressure_systolic.value}
							source={item.blood_pressure_systolic.source}
							color={item.blood_pressure_systolic.color}
							textColor={item.blood_pressure_systolic.textColor}
						/>
					);
				},
			},
			{
				key: HealthData.BLOOD_PRESSURE_DIASTOLIC,
				title: 'Diastólica',
				renderItem: (item: {
					blood_pressure_diastolic: HealthDataTableColumn;
				}) => {
					return (
						<QuestionnaireResultTableItem
							value={item.blood_pressure_diastolic.value}
							source={item.blood_pressure_diastolic.source}
							color={item.blood_pressure_diastolic.color}
							textColor={item.blood_pressure_diastolic.textColor}
						/>
					);
				},
			},
			{
				key: HealthData.HEARTH_RATE,
				title: 'Frecuencia cardiaca',
				renderItem: (item: { heart_rate: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.heart_rate.value}
							source={item.heart_rate.source}
							color={item.heart_rate.color}
							textColor={item.heart_rate.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.BREATHING_RATE]: {
		title: 'component.chart.filter.breathingRate',
		columns: [
			{
				key: HealthData.BREATHING_RATE,
				title: 'component.chart.filter.breathingRate',
				renderItem: (item: { breathing_rate: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.breathing_rate.value}
							color={item.breathing_rate.color}
							textColor={item.breathing_rate.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.WEIGHT]: {
		title: 'base.shared.form.weight.label2',
		columns: [
			{
				key: HealthData.WEIGHT,
				title: 'base.shared.form.weight.label2',
				renderItem: (item: { weight: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.weight.value}
							color={item.weight.color}
							textColor={item.weight.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.HEIGHT]: {
		title: 'component.chart.filter.height',
		columns: [
			{
				key: HealthData.HEIGHT,
				title: 'component.chart.filter.height',
				renderItem: (item: { height: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.height.value}
							color={item.height.color}
							textColor={item.height.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.WAISTLINE]: {
		title: 'base.waistline',
		columns: [
			{
				key: HealthData.WAISTLINE,
				title: 'base.waistline',
				renderItem: (item: { waistline: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.waistline.value}
							color={item.waistline.color}
							textColor={item.waistline.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.STRESS_LEVEL]: {
		title: 'component.chart.filter.stressLevel',
		columns: [
			{
				key: HealthData.SLEEP,
				title: 'component.chart.filter.stressLevel',
				renderItem: (item: { stress_level: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.stress_level.value}
							color={item.stress_level.color}
							textColor={item.stress_level.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.STEPS]: {
		title: 'component.chart.filter.steps',
		columns: [
			{
				key: HealthData.STEP_COUNT,
				title: 'component.chart.filter.steps',
				renderItem: (item: { step_count: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.step_count.value}
							color={item.step_count.color}
							textColor={item.step_count.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.SLEEP]: {
		title: 'component.chart.filter.sleep',
		columns: [
			{
				key: HealthData.SLEEP,
				title: 'component.chart.filter.sleep',
				renderItem: (item: { sleep: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.sleep.value}
							color={item.sleep.color}
							textColor={item.sleep.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.OXYGEN_SATURATION]: {
		title: 'component.chart.filter.oxygenSaturation',
		columns: [
			{
				key: HealthData.OXYGEN_SATURATION,
				title: 'component.chart.filter.oxygenSaturation',
				renderItem: (item: { oxygen_saturation: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.oxygen_saturation.value}
							color={item.oxygen_saturation.color}
							textColor={item.oxygen_saturation.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.HEMOGLOBIN]: {
		title: 'component.chart.filter.hemoglobin',
		columns: [
			{
				key: HealthData.HEMOGLOBIN,
				title: 'component.chart.filter.hemoglobin',
				renderItem: (item: { hemoglobin: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.hemoglobin.value}
							color={item.hemoglobin.color}
							textColor={item.hemoglobin.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.HEMOGLOBIN_A1C]: {
		title: 'component.chart.filter.hemoglobinA1C',
		columns: [
			{
				key: HealthData.HEMOGLOBIN_A1C,
				title: 'component.chart.filter.hemoglobinA1C',
				renderItem: (item: { hemoglobinA1C: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.hemoglobinA1C.value}
							color={item.hemoglobinA1C.color}
							textColor={item.hemoglobinA1C.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.ACTIVE_ENERGY]: {
		title: 'component.chart.filter.activeEnergy',
		columns: [
			{
				key: HealthData.ACTIVE_ENERGY,
				title: 'component.chart.filter.activeEnergy',
				renderItem: (item: { active_energy_burned: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.active_energy_burned.value}
							color={item.active_energy_burned.color}
							textColor={item.active_energy_burned.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.DISTANCE_WALKING_RUNNING]: {
		title: 'component.chart.filter.distanceWalkingRunning',
		columns: [
			{
				key: HealthData.DISTANCE_WALKING_RUNNING,
				title: 'component.chart.filter.distanceWalkingRunning',
				renderItem: (item: {
					distance_walking_running: HealthDataTableColumn;
				}) => {
					return (
						<QuestionnaireResultTableItem
							value={item.distance_walking_running.value}
							color={item.distance_walking_running.color}
							textColor={item.distance_walking_running.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.WORKOUT]: {
		title: 'component.chart.filter.workout',
		columns: [
			{
				key: HealthData.WORKOUT,
				title: 'component.chart.filter.workout',
				renderItem: (item: { workout: HealthDataTableColumn }) => {
					return (
						<QuestionnaireResultTableItem
							value={item.workout.value}
							color={item.workout.color}
							textColor={item.workout.textColor}
						/>
					);
				},
			},
		],
	},
	[Table.BLOOD_GLUCOSE]: {
		title: 'base.glycemia',
		columns: [],
	},
	[Table.MULTIPLE]: {
		title: '',
		columns: [],
	},
};
